import { Directive, Input, OnDestroy, TemplateRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Directive({
    selector: '[paetepNested]'
})
export class NestedDirective implements OnDestroy {
    public id = Math.random();

    @Input('paetepNested') set isVisible(value: boolean) {
        this._isVisible.next(value);
    }

    get isVisible(): boolean {
        return this._isVisible.value;
    }

    @Input('paetepNestedTag') tag?:string = '';

    private _isVisible: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

    get isVisibleObservable() {
        return this._isVisible?.asObservable();
    }

    constructor(
        public templateRef: TemplateRef<any>
    ) {}

    ngOnDestroy(): void {
        this._isVisible.complete();
    }
}
